var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_vm._v(" © 2020 "),_c('strong',[_vm._v(_vm._s(_vm.$t("ukfNitra"))+".")]),_vm._v(" "+_vm._s(_vm.$t("rights_reserved"))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }